module.exports = __webpack_public_path__ + "img/tiyan.306ae697.png";